var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCutTheCost(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 31,
    viewBox: "0 0 36 31",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.12 0C2.76 0 0 2.72 0 6.028c0 2.07 1.083 3.908 2.715 4.995l-.007.013 7.75 4.46-7.75 4.454.014.024C1.086 21.06 0 22.899 0 24.972 0 28.281 2.76 31 6.12 31c3.36 0 6.12-2.72 6.12-6.028 0-2.068-1.08-3.904-2.708-4.992l25.44-14.813h-6.547l-14.56 8.369-4.326-2.52c1.625-1.088 2.701-2.923 2.701-4.988C12.24 2.719 9.48 0 6.12 0zm.566 4c1.44 0 2.571 1.1 2.571 2.5S8.127 9 6.686 9c-.467 0-.895-.125-1.27-.329l-.22-.13A2.454 2.454 0 0 1 4.114 6.5c0-1.4 1.131-2.5 2.572-2.5zm14.278 14-3.478 1.85L29.193 26H36l-15.036-8zM6.686 22c1.44 0 2.571 1.1 2.571 2.5S8.127 27 6.686 27c-1.44 0-2.572-1.1-2.572-2.5S5.245 22 6.686 22z",
    fill: "#E10A0A",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCutTheCost);
export default __webpack_public_path__ + "static/media/cut-the-cost.8dbf96962b4d364f1195f3b4a020cf60.svg";
export { ForwardRef as ReactComponent };